module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/purdue-university-c7773407b8d03099af268b2277f5d166.jpg";